<template>
  <!-- Pozor, overflow-x-hidden zde musi byt jinak na desktopu z nejakeho duvodu na chvili pri animaci ukaze posuvnik ...  -->
  <div class="flex-grow relative overflow-y-auto h-full overflow-x-hidden bg-white rounded-md">
    <transition-group
      :enter-active-class="
        animateBack
          ? 'animate__animated animate__slideInLeft animate__faster'
          : 'animate__animated animate__slideInRight animate__faster'
      "
      :leave-active-class="
        animateBack
          ? 'animate__animated animate__slideOutRight animate__faster'
          : 'animate__animated animate__slideOutLeft animate__faster'
      "
    >
      <ul
        class="LeftNav space-y-3 absolute inset-0 py-3"
        v-show="chooseDomain"
        key="chooseDomain"
      >
        <move-copy-nav-item
          v-for="item in bcDomainStore.domains"
          :key="item.id"
          :title="item.name"
          :item="item"
          :id="'movecopydomain' + item.id"
          :icon="'folder'"
          class="px-3"
        />
      </ul>
      <ul
        class="LeftNav space-y-3 absolute inset-0 py-3"
        v-show="openedItems.length === 0 && chooseDomain === false"
        key="root"
      >
        <li class="LeftNav__Item px-3 border-b border-gray-400">
          <a
            href=""
            class="pl-5 pr-4 flex items-center text-sm"
            @click.stop.prevent="goDomains()"
          >
            <span class="mr-2">
              <aw-icon
                icon="chevron-left"
                class="w-4 h-4 "
              ></aw-icon>
            </span>
            <span class="VisibleAlways">{{ bcMoveCopyStore.selectedDomain ? bcMoveCopyStore.selectedDomain.name : 'Home' }}</span>
          </a>
        </li>
        <li class="LeftNav__Item px-3">
          <a
            href=""
            class="flex items-center text-sm"
            :class="{ 'font-bold': bcMoveCopyStore.selectedItem == bcMoveCopyStore.selectedDomain }"
            @click.stop.prevent="selectHome()"
          >
            <span class="mr-2">
              <aw-icon
                icon="home"
                class="w-4 h-4 "
              />
            </span>
            <span class="VisibleAlways">{{ $t('Home') }}</span>
          </a>
        </li>
        <move-copy-nav-item-recursive
          :children="treeItems" 
          :selected-action="selectedAction"
        />
      </ul>
      <template v-for="stepId in steps" :key="'MoveCopyStep' + stepId">
        <ul
          class="LeftNav space-y-3 absolute inset-0 py-3"
          :id="'MoveCopyStep' + stepId"
          v-show="openedItem?.id === stepId"
        >
          <li class="LeftNav__Item px-3 border-b border-gray-400">
            <a
              href=""
              class="pl-5 pr-4 flex items-center text-sm"
              @click.stop.prevent="goBack()"
            >
              <span class="mr-2">
                <aw-icon
                  icon="chevron-left"
                  class="w-4 h-4 "
                ></aw-icon>
              </span>
              <span class="VisibleAlways">{{ openedItem?.title }}</span>
            </a>
          </li>
          <!-- Teleport menu here! -->
        </ul>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { computed } from 'vue'
import { mapStores } from 'pinia'
import useBcDomainStore from '@/frontapp/store/bcDomain'
import bcFolderStore from '@/frontapp/store/bcFolder'
import bcMoveCopyStore from '@/frontapp/store/bcMoveCopy'

export default {
  props: {
    selectedAction: String,
    bcId: Number,
  },
  data() {
    return {
      steps: [], // list of steps ids
      openedItems: [],
      animateBack: false,
      chooseDomain: false,
    }
  },
  computed: {
    openedItem() {
      if (this.openedItems.length === 0) return null

      return this.openedItems[this.openedItems.length - 1]
    },
    selectedItem() {
      return this.bcMoveCopyStore.selectedItem
    },
    ...mapStores(useBcDomainStore, bcFolderStore, bcMoveCopyStore),
    treeItems() {
      if (this.$route.matched[0].name === 'BCFolder' || this.$route.matched[0].name === 'BCHome') {
        return this.bcMoveCopyStore.treeFolders
      }
      return this.bcMoveCopyStore.tree
    },
    currentDomain() {
      return {
        id: this.bcId,
        name: this.$presenter.rootFolder.name,
        can_edit: this.$presenter.rootFolder.can_edit,
        type: 'domain',
        url: '/'
      }
    }
  },
  methods: {
    goBack() {
      this.animateBack = true
      this.openedItems.pop()
    },
    goDomains() {
      this.animateBack = true
      this.chooseDomain = true
      //this.bcMoveCopyStore.selectedItem = null
    },
    selectHome() {
      this.bcMoveCopyStore.selectedItem = this.bcMoveCopyStore.selectedDomain
    }
  },
  mounted() {
    if (this.bcDomainStore.domains.length === 0) {
      this.bcDomainStore.loadDomains()
    }
    this.bcMoveCopyStore.localBcId = this.bcId
    this.bcMoveCopyStore.selectedDomain = this.currentDomain
    //this.bcMoveCopyStore.selectedItem = this.currentDomain
    this.bcMoveCopyStore.loadFolder(0)
  },
  provide() {
    return {
      addNavStep: (id) => {
        if (this.steps.indexOf(id) === -1) {
          this.steps.push(id)
        }
      },
      openNavStep: (title, icon, id) => {
        this.animateBack = false
        this.openedItems.push({ title, icon, id })
      },
      openedNavStepIds: computed(() => {
        return this.openedItems.map((openedItem) => {
          return openedItem.id
        })
      })
    }
  },
  watch: {
    selectedItem(val) {
      if (!val) {
        this.openedItems = []
        this.bcMoveCopyStore.selectedDomain = this.currentDomain
        this.animateBack = false
        this.chooseDomain = false
      } else if (val.type === 'domain') {
        this.animateBack = false
        this.chooseDomain = false 
      }
    }
  }
}
</script>
